import cuid from "cuid";

export default class Email {
  cuid = cuid();
  email = "";
  isPrimary = false;
  isSelected= false;
}
